import { render } from "./avatar_list.vue?vue&type=template&id=6ba9433e"
import script from "./avatar_list.js?vue&type=script&lang=js&external"
export * from "./avatar_list.js?vue&type=script&lang=js&external"

import "./avatar_list.vue?vue&type=style&index=0&id=6ba9433e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__